import React from "react";

export default [
    [React.createRef(), React.createRef(), React.createRef(), React.createRef(), React.createRef()],
    [React.createRef(), React.createRef(), React.createRef(), React.createRef(), React.createRef()],
    [React.createRef(), React.createRef(), React.createRef(), React.createRef(), React.createRef()],
    [React.createRef(), React.createRef(), React.createRef(), React.createRef(), React.createRef()],
    [React.createRef(), React.createRef(), React.createRef(), React.createRef(), React.createRef()],
    [React.createRef(), React.createRef(), React.createRef(), React.createRef(), React.createRef()],
    [React.createRef(), React.createRef(), React.createRef(), React.createRef(), React.createRef()],
    [React.createRef(), React.createRef(), React.createRef(), React.createRef(), React.createRef()],
];